module.exports = __webpack_public_path__ + "img/chart-2.2ba4b6fb.png";